














































import { defineComponent, computed } from '@vue/composition-api';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';
import successIcon from '@/renderer/assets/images/Icon/svg/successPay.svg';
import { httpUrl } from '@/renderer/scripts/http';
import passwordHandler from '@/renderer/components/user/compositions/passwordHandler';
export default defineComponent({
  components: {
    BaseIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    newUserInfo: {
      type: Object,
      default: {
        nickname: '',
        accountName: '',
        accountPassword: '',
      },
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const loginUrl = `${httpUrl.webUrl}/login`;
    const { copyResetPasswordUrl } = passwordHandler();
    const methods = {
      copyContent() {
        copyResetPasswordUrl({
          type: 'createUser',
          url: loginUrl,
          nickname: props.newUserInfo.nickname,
          accountName: props.newUserInfo.accountName,
          accountPassword: props.newUserInfo.accountPassword,
        });
      },
    };
    return {
      successIcon,
      innerShow,
      loginUrl,
      ...methods,
    };
  },
});
